import React, { useCallback, useEffect, useState } from 'react';
import { Button, Container, Stack, TextField, Typography, CircularProgress, Link } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useAxiosPost } from '../hooks/usePost';
import { getStatusLabel, ShowUserStatusResponse } from '@project_bamboo/shared';

const App: React.FC<{}> = () => {
  const { register, handleSubmit } = useForm();
  const [isSubmitting, setSubmitting] = useState(false);
  const { status, response, postData } = useAxiosPost<ShowUserStatusResponse>('/users/status');

  useEffect(() => {
    setSubmitting(false);
  }, [status]);

  const onSubmit = useCallback(
    (data: any) => {
      setSubmitting(true);
      postData(data);
    },
    [postData],
  );

  if (status === 'error') {
    return (
      <>
        <Container maxWidth="sm" sx={{ pt: 5, marginBottom: 10 }}>
          <Typography variant="body1">
            登録情報がありません。お手数をお掛けしますが竹花塾Discodeサーバーか
            <Link href="https://twitter.com/29_Nom">こちら</Link>までお問い合わせください。
          </Typography>
        </Container>
      </>
    );
  }

  if (status === 'success') {
    const user = response?.data;
    return (
      <>
        <Container maxWidth="sm" sx={{ pt: 5, marginBottom: 10 }}>
          {response?.result && user ? (
            <>
              <Typography variant="body1">登録状況</Typography>
              <Typography variant="body1">名前: {user.name}</Typography>
              <Typography variant="body1">メールアドレス: {user.account}</Typography>
              <Typography variant="body1">累計pt: {user.totalPoint}</Typography>
              <Typography variant="body1">ステータス: {getStatusLabel(user.correctStatus)}</Typography>
              <Typography variant="body1" style={{ fontSize: 10 }}>
                未応募:添削順番ち状態です。準備ができましたら案内をメールで送ります。
              </Typography>
              <Typography variant="body1" style={{ fontSize: 10 }}>
                案内済み:応募フォームのURLをメールで連絡済みです。メールが見つからない場合お問い合わせください。
              </Typography>
              <Typography variant="body1" style={{ fontSize: 10 }}>
                添削待ち:添削申し込みが完了しています。差し替えたい場合は添削申し込み時のメールに記載してある編集用URLから差し替えを行なってください。
              </Typography>

              <Typography variant="body1">
                訂正が必要な場合は竹花塾Discodeサーバーか
                <Link href="https://twitter.com/29_Nom">こちら</Link>までお問い合わせください。
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="body1">{response?.message}</Typography>
              <Typography variant="body1">
                訂正が必要な場合は竹花塾Discodeサーバーか
                <Link href="https://twitter.com/29_Nom">こちら</Link>までお問い合わせください。
              </Typography>
            </>
          )}
        </Container>
      </>
    );
  }

  return (
    <>
      <Container maxWidth="sm" sx={{ pt: 5, marginBottom: 10 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={3}>
            <Typography variant="h4" component="h4">
              FANBOX継続特典申し込み状況
            </Typography>
            <TextField
              required
              label="メールアドレス"
              {...register('account', { required: '必須です', minLength: 1 })}
            />
            <Button color="primary" variant="contained" size="large" type="submit" disabled={isSubmitting}>
              {status === 'loading' ? (
                <CircularProgress
                  size={24}
                  sx={{
                    color: 'primary',
                  }}
                />
              ) : (
                '送信'
              )}
            </Button>
          </Stack>
        </form>
      </Container>
    </>
  );
};

export default App;
